import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ece9cecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card-container",
  style: {"margin-top":"50px"}
}

import ItemCard from '../cards/ItemCard.vue';
    import main from '@/data/main.js';
    import NewsItemCard from '../cards/NewsItemCard.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'StartHere',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(main).has_module_news)
      ? (_openBlock(), _createBlock(NewsItemCard, {
          key: 0,
          title: "Noticias Escuelas Ave María",
          description: _unref(main).TEXT_CARD_NEWS,
          img: _unref(main).NEWS_CARD_IMG,
          route: "notifications"
        }, null, 8, ["description", "img"]))
      : _createCommentVNode("", true),
    (_unref(main).has_module_news)
      ? (_openBlock(), _createBlock(NewsItemCard, {
          key: 1,
          title: "Conoce Nuestro Centro",
          description: _unref(main).TEXT_CENTER,
          img: _unref(main).NEWS_CARD_SCHOOL_IMG,
          route: "center"
        }, null, 8, ["description", "img"]))
      : _createCommentVNode("", true),
    (_unref(main).has_module_routes)
      ? (_openBlock(), _createBlock(ItemCard, {
          key: 2,
          title: "Itinerarios formativos",
          description: _unref(main).ROADMAP_CARD_MAIN_TEXT,
          img: _unref(main).ROUTE_SHEETS_IMG,
          route: "roadmaps"
        }, null, 8, ["description", "img"]))
      : _createCommentVNode("", true),
    _createVNode(ItemCard, {
      title: "Cursos",
      description: _unref(main).COURSE_CARD_MAIN_TEXT,
      img: _unref(main).COURSE_ITEM_IMG,
      route: "courses"
    }, null, 8, ["description", "img"]),
    _createVNode(ItemCard, {
      title: "Certificaciones",
      description: _unref(main).CERTIFICATIONS_CARD_MAIN_TEXT,
      img: _unref(main).CERTIFICATIONS_ITEM_IMG,
      route: "certifications"
    }, null, 8, ["description", "img"]),
    (_unref(main).has_module_employment)
      ? (_openBlock(), _createBlock(ItemCard, {
          key: 3,
          title: "Empleo",
          description: _unref(main).EMPLOY_CARD_MAIN_TEXT,
          img: _unref(main).JOB_ITEM_IMG,
          route: "job-offering"
        }, null, 8, ["description", "img"]))
      : _createCommentVNode("", true),
    (_unref(main).has_module_social)
      ? (_openBlock(), _createBlock(ItemCard, {
          key: 4,
          title: "Foro",
          description: _unref(main).FORUM_CARD_MAIN_TEXT,
          img: _unref(main).FORUM_ITEM_IMG,
          route: "forum"
        }, null, 8, ["description", "img"]))
      : _createCommentVNode("", true),
    (_unref(main).has_module_social)
      ? (_openBlock(), _createBlock(ItemCard, {
          key: 5,
          title: "Red Social",
          description: _unref(main).SOCIAL_NETWORK_CARD_MAIN_TEXT,
          img: _unref(main).SOCIAL_ITEM_IMG,
          route: "my-wall"
        }, null, 8, ["description", "img"]))
      : _createCommentVNode("", true),
    (_unref(main).has_module_faqs)
      ? (_openBlock(), _createBlock(ItemCard, {
          key: 6,
          title: "Preguntas frecuentes",
          description: _unref(main).FAQS_CARD_MAIN_TEXT,
          img: _unref(main).FAQS_ITEM_IMG,
          route: "faqs"
        }, null, 8, ["description", "img"]))
      : _createCommentVNode("", true),
    (_unref(main).has_module_support)
      ? (_openBlock(), _createBlock(ItemCard, {
          key: 7,
          title: "Te escuchamos",
          description: _unref(main).SUPPORT_CARD_MAIN_TEXT,
          img: _unref(main).SUPPORT_ITEM_IMG,
          route: "friends"
        }, null, 8, ["description", "img"]))
      : _createCommentVNode("", true)
  ]))
}
}

})